
import { SalesMetricsBasic } from "@/pages/admin/sales";

interface MetricConfig {
  title: string;
  description: string;
  value: number | null;
  icon: string;
  color: string;
  onClick?: () => void;
  getValue: (data: SalesMetricsBasic | undefined) => string;
  policies?: any[];
}

interface MetricClickHandlers {
  onDailyClick: () => void;
  onWeeklyClick: () => void;
  onMonthlyClick: () => void;
  onYearlyClick: () => void;
}

// Format currency with commas and decimal places
const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '$0';
  return `$${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
};

export const createMetricsConfig = (
  data: SalesMetricsBasic | undefined,
  handlers: MetricClickHandlers
): MetricConfig[] => [
  {
    title: 'Daily Sales',
    description: 'Total of policy premiums (base + endorsement) for policies sold or endorsed today',
    value: data?.dailyTotal || 0,
    icon: 'daily',
    color: 'bg-blue-500',
    onClick: handlers.onDailyClick,
    getValue: (data) => formatCurrency(data?.dailyTotal || 0),
  },
  {
    title: 'Weekly Sales',
    description: 'Total of policy premiums (base + endorsement) for policies sold or endorsed this week',
    value: data?.weeklyTotal || 0,
    icon: 'weekly',
    color: 'bg-green-500',
    onClick: handlers.onWeeklyClick,
    getValue: (data) => formatCurrency(data?.weeklyTotal || 0),
  },
  {
    title: 'Monthly Sales',
    description: 'Total of policy premiums (base + endorsement) for policies sold or endorsed this month',
    value: data?.monthlyTotal || 0,
    icon: 'monthly',
    color: 'bg-purple-500',
    onClick: handlers.onMonthlyClick,
    getValue: (data) => formatCurrency(data?.monthlyTotal || 0),
  },
  {
    title: 'Year to Date',
    description: 'Total of policy premiums (base + endorsement) for policies sold or endorsed this year',
    value: data?.yearlyTotal || 0,
    icon: 'yearly',
    color: 'bg-orange-500',
    onClick: handlers.onYearlyClick,
    getValue: (data) => formatCurrency(data?.yearlyTotal || 0),
  }
];
